module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar.component.scss
// module id = ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar.component.scss
// module chunks = main